module.exports = "../../app/cells/components/modals/setup_wizard/location.erb";